import { defineMessages } from "react-intl";

const messages = defineMessages({
    copyright: {
        id: "footer.copyright",
    },
    contact: {
        id: "contact.title",
    },
    privacy: {
        id: "privacy.title",
    },
    terms: {
        id: "footer.terms",
    },
});

export default messages;
